var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3346 5.00113C36.7386 6.12693 34.9715 6.98798 33.1013 7.55113C32.0975 6.39699 30.7635 5.57895 29.2797 5.20768C27.7959 4.8364 26.2338 4.92979 24.8048 5.47522C23.3757 6.02065 22.1487 6.9918 21.2896 8.25733C20.4305 9.52285 19.9808 11.0217 20.0013 12.5511V14.2178C17.0724 14.2937 14.1701 13.6442 11.553 12.3269C8.93587 11.0096 6.68516 9.06553 5.0013 6.6678C5.0013 6.6678 -1.66536 21.6678 13.3346 28.3345C9.90218 30.6644 5.81323 31.8327 1.66797 31.6678C16.668 40.0011 35.0013 31.6678 35.0013 12.5011C34.9998 12.0369 34.9551 11.5738 34.868 11.1178C36.569 9.44029 37.7693 7.32232 38.3346 5.00113Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4d36dc9f4fac24469f8c62dda529caf7.svg";
export { ForwardRef as ReactComponent };